var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{staticClass:"c-file flex"},[_c('i',{staticClass:"tf tf-fw tf-file",class:`tf-file-${_vm.suffix}`}),_c('a',{on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.fileName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }